import { addDays, format, parse } from 'date-fns';
import { fetchSlots } from './providers/slots';

export default function rescheduleAppointment(currentDate, professionalId) {
    return {
        open: false,
        date: currentDate,
        time: '',
        slots: [],
        init() {
            this.fetch();
            this.$watch('date', () => {
                this.time = '';
                this.fetch();
            });
        },
        isoDate() {
            return this.date && this.time ? parse(`${this.date} ${this.time}`, 'yyyy-MM-dd HH:mm', new Date()).toISOString() : '';
        },
        async fetch() {
            if (this.date) {
                try {
                    const fromDate = parse(`${this.date} 00:00`, 'yyyy-MM-dd HH:mm', new Date());
                    const from = fromDate.toISOString();
                    const to = addDays(fromDate, 1).toISOString();
                    const response = await fetchSlots({ professional_id: professionalId, from, to });
                    this.slots = response.map(({ start, isAvailable }) => {
                        const time = format(new Date(start), 'HH:mm');
                        return { time, isAvailable };
                    });
                } catch {
                    this.slots = [];
                }
            }
        },
    };
}
